<e-vault-navbar></e-vault-navbar>
<div class="p-4 4xl:mx-auto 4xl:max-w-screen-2xl">
  <router-outlet></router-outlet>
</div>
